/**
 * Extracts a human-readable error message.
 *
 * ChiroUpAPI normalizes Amplify rejections into `{ response: { data: { ... } } }`,
 * where `data` is the parsed lambda response body.
 * BE sometimes returns `errorMessage` and sometimes `message` (older paths),
 * so we check both before falling back.
 */
export const extractApiErrorMessage = (err: unknown, fallbackMsg: string): string => {
  const e = err as
    | {
        response?: { data?: { errorMessage?: string; message?: string } };
        message?: string;
      }
    | null
    | undefined;

  const message =
    e?.response?.data?.errorMessage || e?.response?.data?.message || e?.message || fallbackMsg;

  return typeof message === 'string' ? message.trim() || fallbackMsg : fallbackMsg;
};
